import React, { useState, useEffect, useMemo } from 'react';
import YardDropdown from "../components/YardDropdown";
import { FaMapMarkerAlt } from 'react-icons/fa';

const DeviceOutages = () => {
    const [allOutages, setAllOutages] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [yards, setYards] = useState([]);
    const [yardFilter, setYardFilter] = useState('all');
    const [durationFilter, setDurationFilter] = useState(0);

    const serverUrl = process.env.REACT_APP_API_SERVER_URL;

    useEffect(() => {
        const fetchYards = async () => {
            try {
                if (!serverUrl) return;
                const response = await fetch(`${serverUrl}/maiApi/yards`);
                if (!response.ok) throw new Error('Could not fetch yards list.');
                const data = await response.json();
                setYards(data);
            } catch (err) {
                console.error("Failed to fetch yards:", err);
            }
        };

       const fetchOutages = async () => {
            if (!serverUrl) return;
            setIsLoading(true);
            setError(null);

            const endpoint = yardFilter === 'all'
                ? `${serverUrl}/maiApi/network-outages/top10`
                : `${serverUrl}/maiApi/network-outages/yard/${yardFilter}`;

            try {
                const response = await fetch(endpoint);
                if (!response.ok) throw new Error('Failed to fetch outage data');
                const data = await response.json();
                setAllOutages(data);
            } catch (e) {
                setError(e.message);
            } finally {
                setIsLoading(false);
            }
        }

        fetchYards();
        fetchOutages();
    }, [yardFilter, serverUrl]);

    const filteredOutages = useMemo(() => {
        const durationFiltered = allOutages.filter(device =>
        
            device.outage_duration_hours >= durationFilter
        );
        const latestOutagesMap = new Map();
        durationFiltered.forEach(device => {
            const existingOutage = latestOutagesMap.get(device.android_id);
            if (!existingOutage || new Date(device.date_time) > new Date(existingOutage.date_time)) {
                latestOutagesMap.set(device.android_id, device);
            }
        });
        return Array.from(latestOutagesMap.values());
    }, [allOutages, durationFilter]);

  
const getCellClass = (duration) => {
    if (duration >= 24) {
       
        return "bg-red-200 text-red-700 font-bold";
    }
    return "";
};
   
     const handleMapClick = (lat, lng) => {
      if (lat && lng) {
        const mapUrl = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
        window.open(mapUrl, '_blank'); 
      }
    };
    
    const headers = ['Android ID', 'GPS', 'Yard', 'Last Seen', 'Outage Duration (hrs)', 'Charge %', 'Charging', ' Battery Health', 'LTE dBm', 'WiFi Strength'];

   
    const cellStyle = "px-6 py-4 whitespace-nowrap text-base text-text-main font-sans"; 

    return (
        <div className="p-4 sm:p-8 md:p-10 font-sans">
            <h1 className="text-3xl font-bold text-text-main mb-6 text-center">
                Device Outages
            </h1>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                <div className="md:col-span-1"></div>
               <YardDropdown
    value={yardFilter === "all" ? "" : yardFilter}
    onChange={(val) => setYardFilter(val || "all")}
    className="md:col-span-1"
/>

                <select
                    className="md:col-span-1 form-select border-border-color rounded-md shadow-sm"
                    value={durationFilter}
                    onChange={(e) => setDurationFilter(Number(e.target.value))}
                >
                    <option value="0">Any Duration</option>
                    <option value="6">6 Hours</option>
                    <option value="12">12 Hours</option>
                    <option value="24">1 Day</option>
                    <option value="72">3 Days</option>
                </select>
                <div className="md:col-span-1"></div>
            </div>

            {error && <p className="text-center p-4 text-danger-dark">Error: {error}</p>}

            <div className="overflow-x-auto bg-white rounded-lg shadow border border-border-color">
                <table className="min-w-full divide-y divide-border-color">
                    <thead style={{ backgroundColor: '#1d4ed8' }}>
                        <tr>
                            {headers.map((header, index) => (
                                <th
                                    key={header}
                                    scope="col"
                                    
                                    className={`px-2 py-2 text-center text-base font-bold text-white   ${index < headers.length - 1 ? 'border-r border-blue-500' : ''}`}
                                >
                                    {header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-border-color">
                        {isLoading ? (
                            <tr><td colSpan={headers.length} className="text-center p-6 text-text-light">Loading outages...</td></tr>
                        ) : filteredOutages.length > 0 ? (
                            filteredOutages.map((device) => (
                                <tr key={device.android_id} className="hover:bg-background">
                                   
                                    <td className={`${cellStyle} font-mono border-r border-border-color`}>{device.android_id}</td>
                                    
                                    <td className={`${cellStyle} border-r border-border-color`}>
  {device.gps && device.gps.includes(":") ? (
    (() => {
      const [lat, lon] = device.gps.split(":");
      const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${lat},${lon}`;
      return (
        <a
          href={googleMapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          title={`View on Google Maps (${lat}, ${lon})`}
          className="flex justify-center items-center text-blue-600 hover:text-blue-800"
        >
          <FaMapMarkerAlt size="1.3em" />
        </a>
      );
    })()
  ) : (
    "N/A"
  )}
</td>

                                    <td className={`${cellStyle} border-r border-border-color`}>{device.yard_name || 'N/A'}</td>
                                    <td className={`${cellStyle} border-r border-border-color`}>{new Date(device.date_time).toLocaleString()}</td>
                                    <td className={`${cellStyle} ${getCellClass(device.outage_duration_hours)} border-r border-border-color`}>
                                        {device.outage_duration_hours.toFixed(2)} hrs
                                    </td>
                                    <td className={`${cellStyle} font-bold border-r border-border-color`}>{device.battery_percent}%</td>
                                    <td className={`${cellStyle} border-r border-border-color`}>{device.charging_state === 'true' ? 'Charging' : 'Discharging'}</td>
                                    <td className={`${cellStyle} capitalize border-r border-border-color`}>{device.health_status}</td>
                                    <td className={`${cellStyle} border-r border-border-color`}>{device.lteDbm || 'N/A'}</td>
                                    <td className={cellStyle}>{device.wifiStretch || 'N/A'}%</td>
                                </tr>
                            ))
                        ) : (
                            <tr><td colSpan={headers.length} className="text-center p-6 text-text-light">No device outages found.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default DeviceOutages;
